import { render, staticRenderFns } from "./CodeComponent.vue?vue&type=template&id=dc2b2bcc&scoped=true"
import script from "./CodeComponent.vue?vue&type=script&lang=js"
export * from "./CodeComponent.vue?vue&type=script&lang=js"
import style0 from "./CodeComponent.vue?vue&type=style&index=0&id=dc2b2bcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc2b2bcc",
  null
  
)

export default component.exports